export default {
      id: "apps-usage",
      viewBox: "0 0 20 20",
      url: "assets/" + "sprite.svg#apps-usage",
      toString: function () {
        return this.url;
      }
    }